import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门竞猜分类
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-xl mx-auto">
            华体会官网覆盖全球主流体育赛事，选择您感兴趣的项目开始竞猜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center bg-background-50 rounded-lg p-6 border border-background-200/60 hover:border-accent-300 hover:bg-accent-50/50 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-accent-100 rounded-full mb-4 group-hover:bg-accent-200 transition-all duration-300">
                <i className={`${cat.icon} text-accent-700 text-2xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                {cat.description}
              </p>
              <span className="text-xs text-accent-700 font-medium">
                {cat.matchCount}场赛事
                <i className="ri-arrow-right-line ml-1 inline-block group-hover:translate-x-0.5 transition-transform duration-200"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}